<template>
  <div :class="$style['case__status']">
    <div
      v-if="showLimitStatus"
      :class="[
        $style['case__status-item'],
        $style['case__status-item--opened'],
      ]"
    >
      <IconClock :class="$style['case__status-icon']" />
      {{ toLocalNumber(props.limitCount ?? 0) }} /
      {{ toLocalNumber(props.limitTotal ?? 0) }}
    </div>

    <div
      v-if="props.discount"
      :class="[
        $style['case__status-item'],
        $style['case__status-item--discount'],
      ]"
    >
      {{ props.discount }}
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  discount?: string;
  limitCount?: number;
  limitTotal?: number;
}>();

const showLimitStatus = computed(
  () => props.limitCount !== undefined && props.limitTotal !== undefined,
);
</script>

<style module lang="scss">
.case__status {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  position: absolute;
  left: 0.75rem;
  top: 0.75rem;
}

.case__status-icon {
  fill: $yellow;
  width: 1rem;
  height: 1rem;
}

.case__status-item {
  font-weight: 500;
  line-height: 115%;
  letter-spacing: -0.024px;
  display: flex;
  padding: 0 12px;
  font-size: 14px;
  align-items: center;
  gap: 6px;
  border-radius: 20px;
  flex-shrink: 0;
  backdrop-filter: blur(20px);
  height: 32px;

  @media screen and (max-width: 800px) {
    font-size: 12px;
    padding: 0 6px;
    height: 24px;
  }
}

.case__status-item--opened {
  background: rgba(255, 199, 0, 0.06);
  color: $yellow;
  padding: 0 12px 0 8px;

  @media screen and (max-width: 800px) {
    padding: 0 8px 0 4px;
  }
}

.case__status-item--discount {
  background: rgba(255, 51, 51, 0.06);
  color: #f85454;
}
</style>
